export default __webpack_public_path__ + "static/media/opinion.f2f6a06e.svg";